// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"image-search"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17.6538 21.8077C15.3597 21.8077 13.4999 19.948 13.4999 17.6538C13.4999 15.3597 15.3597 13.5 17.6538 13.5C19.9479 13.5 21.8076 15.3597 21.8076 17.6538C21.8076 19.948 19.9479 21.8077 17.6538 21.8077Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 10V3H3V21H10M11.5 12.5L9 10L3.5 15.5M17.75 8.25C17.75 9.35457 16.8546 10.25 15.75 10.25C14.6454 10.25 13.75 9.35457 13.75 8.25C13.75 7.14543 14.6454 6.25 15.75 6.25C16.8546 6.25 17.75 7.14543 17.75 8.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.5924 20.5897C21.3433 19.8381 21.8077 18.8002 21.8077 17.6538C21.8077 15.3597 19.948 13.5 17.6538 13.5C15.3597 13.5 13.5 15.3597 13.5 17.6538C13.5 19.948 15.3597 21.8077 17.6538 21.8077C18.8016 21.8077 19.8406 21.3422 20.5924 20.5897ZM20.5924 20.5897L22.5 22.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ImageSearchIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'image-search',
    ref,
    icon: element,
  },
));

ImageSearchIcon.displayName = 'ImageSearchIcon';

export default ImageSearchIcon;
